import { useCoastguard } from "@cofano/coastguard2-frontend-client";
import "../../gql/fragments";
import { useMutation } from "@apollo/client";
import { UpdateFavoritesDocument, UpdateFavoritesMutationVariables } from "__generated__/graphql/mutations.generated";

export function useUserFavorites() {
	const { instance: { forceRefreshAccessTokenAndUserDetails, getUserDetails: userDetails } } = useCoastguard();
	const [ updateUserFavorites ] = useMutation(UpdateFavoritesDocument);

	return async (favorite: UpdateFavoritesMutationVariables["input"]) => {
		if (!userDetails) {
			return;
		}

		await updateUserFavorites({
			variables: {
				accountUuid: userDetails.accountUuid,
				input: favorite,
			},
		});

		await forceRefreshAccessTokenAndUserDetails();
	};

}
